import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { DebtStateResponse } from '../models/debt-states.model';
import { DebtYearResponse } from '../models/debt-year.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DebtService {

  private apiUrl = `${environment.sgcApi}`;
  private debtRoute = 'debt';

  constructor(
    private httpClient: HttpClient
  ) {}

  getDebtStates() : Observable<DebtStateResponse[]> {
    return this.httpClient.get<DebtStateResponse[]>(`${this.apiUrl}${this.debtRoute}/state`)
      .pipe(map((data) => data));
  }

  getDebtYears() : Observable<DebtYearResponse[]> {
    return this.httpClient.get<DebtYearResponse[]>(`${this.apiUrl}${this.debtRoute}/year`)
      .pipe(map((data) => data));
  }
}
